import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found',
  template: `
    <article class="container main">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>Page non trouvée</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Cette page n'existe pas.</p>
        </mat-card-content>
        <mat-card-actions>
          <a mat-raised-button color="accent" routerLink="/">
            Retour à l'accueil
          </a>
        </mat-card-actions>
      </mat-card>
    </article>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatCardModule],
})
export class NotFoundComponent {}
